import Vue from 'vue'
const state = {
    filter: {
       region_id: 0,
       forestry_id: 0,
       localforestry_id: 0,
       subforestry_id: 0,
       kv: []
    },
    ppnItems:[]
  }
  
  const mutations = {
    setGlpmFilter(state, {type, items}) {
      state['filter'][type] = items
    },
    setGlpmFilterObj(state, {items}) {
      state['filter'] = items
    },
  }
  
  const actions = {
    getPpnCards(context) {
        return Vue.http.post('php_scripts/glpm/getPpnCards.php', state.filter, {emulateJSON: true}).then((res) => {
          state.ppnItems = res.data
        }).catch((err) => {
          console.log(err)
        })
    }
  }
  
  const getters = {
    
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }